/**
 * A reference to a versioned identifiable model at a specific version.
 */
import { checkDefined } from 'faro-common-model';
export function toVersionedReference(reference) {
    checkDefined(reference.id, 'VersionedReference', 'id');
    checkDefined(reference.version, 'VersionedReference', 'version');
    return {
        id: reference.id,
        version: reference.version,
    };
}
//# sourceMappingURL=versioned-reference.js.map